'use client';

import { SDKResponse } from '@commercetools/frontend-sdk';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import AddToCartProvider from '@/context/addToCartProvider';
import { ProductDetailsProvider } from '@/context/productDetailProvider';
import { sdk } from 'sdk';
import I18nProvider from './i18n';
import ProjectSettingsProvider from '../frontastic/hooks/useProjectSettings/useProjectSettings';
import { GetAccountActionReturn } from '../sdk/composable-commerce/types/actions/AccountActions';

interface ProvidersProps {
  translations?: any;
  accountResult?: SDKResponse<GetAccountActionReturn>;
  projectSettings?: ProjectSettings;
  responseData?: any;
}

export const Providers = ({
  translations,
  children,
  projectSettings,
  responseData,
}: React.PropsWithChildren<ProvidersProps>) => {
  sdk.defaultConfigure('en');

  return (
    <I18nProvider translations={translations}>
      <ProjectSettingsProvider projectSettings={projectSettings}>
        <ProductDetailsProvider data={responseData} projectSettings={projectSettings}>
          <AddToCartProvider>{children}</AddToCartProvider>
        </ProductDetailsProvider>
      </ProjectSettingsProvider>
    </I18nProvider>
  );
};
